class SecDep {
  static check = () => {
    return new Promise((resolve) => {
      if(window.pd_sec_dependency) {
        window.pd_sec_dependency.forEach((secDep) => {
          let p = [];
          let s = document.querySelector(".drform ." + secDep.secondary);
          switch(secDep.condition.type) {
            case "visible":
              p = document.querySelector(".drform ." + secDep.primary);
              if(p.classList.contains("hidden")) {
                if(!s.classList.contains("hidden")){
                  s.classList.add("hidden");
                }
              } else {
                let pv = document.querySelector(".drform ." + secDep.primary + " .sc-dropdown__single-value");
                if(pv) {
                  let pvv = pv.innerHTML;
                  let con = secDep.condition.primaryValues
                    .map((m) => m.trim().toLowerCase())
                    .includes(pvv.trim().toLowerCase());
                  if(con) {
                    // Show secondary
                    if(s.classList.contains("hidden")){
                      s.classList.remove("hidden");
                    }
                  } else {
                    if(!s.classList.contains("hidden")){
                      s.classList.add("hidden");
                    }
                  }                 
                } else {
                  // not found hide secondary
                  if(s && !s.classList.contains("hidden")){
                    s.classList.add("hidden");
                  }                 
                }
              }
              break;
            case "simple-visible":
              p = document.querySelector(".drform ." + secDep.primary);
              if(p.classList.contains("hidden")) {
                if(!s.classList.contains("hidden")){
                  s.classList.add("hidden");
                }
              } else {
                if(s.classList.contains("hidden")){
                  s.classList.remove("hidden");
                }
              }
              break;
            case "complex_hide_when_not":
              // primary is a collection
              let isFound = false;
              secDep.primary.forEach((sdp,i) => { 
                p = document.querySelector(".drform ." + sdp + " .sc-dropdown__single-value");
                if(p) {
                  let pov = p.innerHTML;
                  let con = secDep.condition.primaryValues[sdp]
                    .map((m) => m.trim().toLowerCase())
                    .includes(pov.trim().toLowerCase());
                  if(con) {
                    isFound = true;
                  }
                }
              });
              if (!isFound && !s.classList.contains("hidden")) {
                s.classList.add("hidden");
              }
              break;
            default: 
              //do nothing.
          }
        });
      }
      resolve("done");
    } );
  }
}

export {SecDep};
